<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Beware and Stogie</span></p>
<p class="bk-subtitle"><span>Beware the Mare, Book Four</span></p>
<p class="authorname"><span>Jessie Haas</span></p>
<p class="publisher"><span><img alt="image" class="svg" src="images/fig_01.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?368dbad9